module.exports = __webpack_public_path__ + "static/media/2019-Mustang-Convertible-V8.fc3e341a.jpg";